import React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material';

// Styled Button
interface IStyledToggleButton {
  selected: boolean;
}

const StyledToggleButton = styled(Button)<IStyledToggleButton>(({ theme, selected }) => ({
  width: '125px',
  height: '45px',
  borderRadius: '8px',
  fontWeight: 400,
  border: selected ? `1px solid ${theme.palette.primary.main}` : '1px solid #2A3C67',
  backgroundColor: selected ? theme.palette.primary.main : '#fff',
  color: selected ? '#fff' : '#2A3C67',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: selected ? theme.palette.primary.dark : '#f5f5f5',
  },
}));
export default StyledToggleButton;
